/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var STYLE = {
  display: 'inline-block'
};
var _default = function _default(content) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'empty';
  var style = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof content === 'function') {
    content = content();
  }
  if (content == null || content == false || content == '') {
    return null;
  }
  if (typeof content === 'string') {
    content = _react.default.createElement("div", {
      className: "InovuaReactDataGrid__".concat(name, "-text"),
      style: STYLE
    }, content);
  }
  return _react.default.createElement("div", {
    key: "emptyContentWrapper",
    className: "InovuaReactDataGrid__".concat(name, "-wrapper"),
    style: style
  }, content);
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/renderEmptyContent.js
// module id = 270
// module chunks = 0